<template>
  <div class="md-layout text-center login-fix-page">
    <div class="md-layout-item md-size-100">
      <div class="text-center">
      </div>
      <div class="text-center" style="margin-bottom: 32px;">
      </div>
    </div>

    <div
      class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100 login-page-fix"
    >
      <form @submit.prevent="login">
        <login-card header-color="green">
          <h4 slot="title" class="title">原來是洋蔥</h4>
          <md-field
            class="form-group md-invalid"
            slot="inputs"
            style="margin-bottom: 28px"
          >
            <md-icon>fingerprint</md-icon>
            <label>手機號碼(登入帳號)</label>
            <md-input v-model="mobile" type="text" />
            <validation-error :errors="apiValidationErrors.mobile" />
          </md-field>
          <md-field class="form-group md-invalid" slot="inputs">
            <md-icon>lock_outline</md-icon>
            <label>密碼</label>
            <md-input v-model="password" type="password" />
          </md-field>
          <md-button
            slot="footer"
            class="md-simple md-success md-lg"
            type="submit"
          >
            登入
          </md-button>
        </login-card>
        <md-button class="md-round" href="/register" >註冊</md-button><br>
        <md-button class="md-round" href="/forget" >忘記密碼</md-button>
      </form>
    </div>
  </div>
</template>

<script>
import { LoginCard, ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";
import Swal from "sweetalert2";

export default {
  components: {
    LoginCard,
    ValidationError,
  },
  mixins: [formMixin],
  computed: {
    isAuthenticated: function() {
      return this.$store.getters.isAuthenticated();
    },
  },
  data: () => ({
    mobile: "",
    password: "",
  }),
  methods: {
    login() {
      const user = {
        data: {
          type: "token",
          attributes: {
            mobile: this.mobile,
            password: this.password,
          },
        },
      };

      const requestOptions = {
        headers: {
          Accept: "application/vnd.api+json",
          "Content-Type": "application/vnd.api+json",
        },
      };

      Swal.fire({
        title: "寄庫到期日退款須知",
        html: "按下 我同意 '退款修款' 後登入會員!<br /> 寄庫有價格優惠，有效期限後請至門市辦理退款。<br /> 退款金額 = 購買金額 - (領用片數 x 單片原價)",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "我同意 '退款修款'",
        cancelButtonText: "取消",
      }).then((result) => {
        const { value: isConfirm = false } = result;
        if (isConfirm === true) {

          this.$store.dispatch("login", { user, requestOptions })
            .catch((error) => {
              this.$store.dispatch("alerts/error", "登入失敗!");
              this.setApiValidation(error.response.data.errors);
            });

        }
      });
    },


  },
};
</script>
<style scoped>
.login-fix-page {
  padding-bottom: 7em;
  padding-top: 4em;
}
</style>
